import BaseModel from '../core/BaseModel'
export default class RequestReturnProductModel extends BaseModel {
    constructor() {
        super({ 
                name: "request_return_product",
                tableName: 'core_request_return_product'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            created_date: { 
                name: 'created_date', 
                type: "CustomDateTime", 
                label: 'Ngày đổi trả',
                class: 'top-datepicker',
                sortable: false,
                width: 15,
                filter: { type: 'DateRange', match: 'custom'}
            },
            serialNumber: { 
                name: 'serialNumber', 
                label: 'Serial number',
                class: 'center',
                type: "String",
                sortable: false,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                   data.serialNumber = (data.serial_number != undefined && data.serial_number != null) ? data.serial_number.serial_number : '';
                }
            },
            modelCode: { 
                name: 'modelCode', 
                label: 'Model sản phẩm',
                class: 'center',
                type: "String",
                sortable: false,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    var productData = (data.serial_number != undefined && data.serial_number != null) ? data.serial_number : null;
                    if(productData != null) {
                        data.modelCode =  (productData.product != undefined && productData.product != null && productData.product.model_code != undefined) ? productData.product.model_code : '';
                    }
                }
            },
            product_name: { 
                name: 'product_name', 
                label: 'Tên sản phẩm',
                class: 'center',
                type: "String",
                sortable: false,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    var productData = (data.serial_number != undefined && data.serial_number != null) ? data.serial_number : null;
                    if(productData != null) {
                        data.product_name =  (productData.product != undefined && productData.product != null && productData.product.name != undefined) ? productData.product.name : '';
                    }
                }
            },
            return_type: {
                name: 'return_type', label: 'Loại dịch vụ', type: "Selection",  dataType: 'Label',  class: 'center', width: 15,
                options: [{ value: 1, label: 'Trả sản phẩm'}, { value: 0, label: 'Đổi sản phẩm'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                sortable: false
            },
            customer_profile_id: {
                refs: 'user_created serial_number_id  serial_number_product { warranty_status } serial_number {  serial_number product { model_code name } }',
                display: false
            }
        },)
    }

}